import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {} }
const _hoisted_2 = { class: "flex gap-[12px] my-[8px] max-w-[1624px] mx-auto w-full" }

import datePicker from '@/components/date-picker/date-picker.vue';
import { Dashboard_InitiatorType, Dashboard_WorkloadType } from '@/graphql/codegen/generated/graphql';
import { computed, ref } from 'vue';
import moment from 'moment';
import { useOsService } from '@/services/OsService/OsService';
import { workloadTypesLabels, initiatorTypesLabels } from '@/views/dashboard/dashboard.const';
import { IncrediNote } from 'incredi-ui';
import { useI18n } from 'vue-i18n';
import { useMatomo } from '@/services/matomo/matomo.service';
import SelectionMenu from './components/selection-menu.vue';
import { useDashboardFilters } from './dashboard-filter.provider';
import { useFilteredDashboardMetadata } from '../../dashboard.provider';


export default /*#__PURE__*/_defineComponent({
  __name: 'dashboard-filter-bar',
  setup(__props) {

const { t } = useI18n();
const matomo = useMatomo();
const datePickerRef = ref();

const osService = useOsService();
const GQL_dashboardMetadataQuery = useFilteredDashboardMetadata();

const { rangeDate, initiatorType, workloadType, buildGroup, setInitiatorFilter, setBuildGroupFilter, setRangeDateFilter, setWorkloadFilter } = useDashboardFilters();

const workloadsTypesFiltered = computed(() => {
  const workloadsTypes = Object.keys(workloadTypesLabels).filter(type =>
    GQL_dashboardMetadataQuery.result.value?.dashboardMetadata?.workloadTypes?.includes(type as Dashboard_WorkloadType),
  ) as Dashboard_WorkloadType[];

  return workloadsTypes.map(key => workloadTypesLabels[key]);
});
const initiatorTypesFiltered = computed(() => {
  const initiatorTypes = Object.keys(initiatorTypesLabels).filter(type =>
    GQL_dashboardMetadataQuery.result.value?.dashboardMetadata?.initiatorTypes?.includes(type as Dashboard_InitiatorType),
  ) as Dashboard_InitiatorType[];

  return initiatorTypes.map(key => initiatorTypesLabels[key]);
});

const rangeDateComputed = computed<any>({
  get: () => {
    if (!GQL_dashboardMetadataQuery.result.value?.dashboardMetadata?.hasWorkloads)
      return {
        from: null,
        to: null,
      };
    return rangeDate.value;
  },
  set: value => {
    if (value.from && value.to) {
      setRangeDateFilter(value);
    }
  },
});

const dateToLimitationFn = (
  date: string,
  localDate: {
    from: string;
    to: string;
  },
) => {
  const dateLimit = moment(localDate.from, 'YYYY/MM/DD').add(30, 'days').format('YYYY/MM/DD');
  return date <= moment().format('YYYY/MM/DD') && dateLimit >= date;
};

const dateFromLimitationFn = (date: string) => {
  const dateLimit = moment(GQL_dashboardMetadataQuery.result.value?.dashboardMetadata?.oldestWorkloadDate).format('YYYY/MM/DD');
  return date >= dateLimit;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(datePicker, {
        ref_key: "datePickerRef",
        ref: datePickerRef,
        "model-value": _unref(rangeDateComputed),
        "max-days": 30,
        "date-to-limitation-fn": dateToLimitationFn,
        "date-from-limitation-fn": dateFromLimitationFn,
        "navigation-min-year-month": _unref(moment)(_unref(GQL_dashboardMetadataQuery).result.value?.dashboardMetadata?.oldestWorkloadDate).format('YYYY/MM'),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = 
          value => {
            rangeDateComputed.value = value;
            _unref(matomo)?.trackEvent({
              category: 'Dashboard Filter',
              action: 'Apply Date',
              name: datePickerRef.value?.buttonLabel || '',
            });
          }
        )
      }, {
        "date-picker-prepend": _withCtx(() => [
          _createVNode(_unref(IncrediNote), {
            type: "Information",
            class: "mt-[16px] px-[16px]"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(t)('dashboard.datePicker.notes.input')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model-value", "navigation-min-year-month"]),
      (_unref(initiatorTypesFiltered).length && _unref(osService).isWindows.value)
        ? (_openBlock(), _createBlock(SelectionMenu, {
            key: 0,
            "model-value": _unref(initiatorType) ? _unref(initiatorTypesLabels)[_unref(initiatorType)] : null,
            label: "Initiator Type",
            options: _unref(initiatorTypesFiltered),
            "onUpdate:modelValue": _cache[1] || (_cache[1] = value =>{
            initiatorType.value = (Object.keys(_unref(initiatorTypesLabels)) as Dashboard_InitiatorType[]).find(key => _unref(initiatorTypesLabels)[key] === value) || null;
            _unref(setInitiatorFilter)(_unref(initiatorType) as Dashboard_InitiatorType);
            _unref(matomo)?.trackEvent({
              category: 'Dashboard Filter',
              action: 'Apply build group',
              name: value || '',
            });
        })
          }, null, 8, ["model-value", "options"]))
        : _createCommentVNode("", true),
      _createVNode(SelectionMenu, {
        "model-value": _unref(buildGroup),
        searchable: "",
        label: "Build Group",
        options: _unref(GQL_dashboardMetadataQuery).result.value?.dashboardMetadata?.buildGroups?.map(buildGroup => buildGroup || '') || [],
        "onUpdate:modelValue": _cache[2] || (_cache[2] = 
          value => {
            _unref(setBuildGroupFilter)(value || null);
            _unref(matomo)?.trackEvent({
              category: 'Dashboard Filter',
              action: 'Apply build group',
              name: value || '',
            });
          }
        )
      }, null, 8, ["model-value", "options"]),
      (_unref(workloadsTypesFiltered).length > 1 && _unref(osService).isWindows.value)
        ? (_openBlock(), _createBlock(SelectionMenu, {
            key: 1,
            "model-value": _unref(workloadType) ? _unref(workloadTypesLabels)[_unref(workloadType)] : null,
            label: "Build Type",
            options: _unref(workloadsTypesFiltered),
            "onUpdate:modelValue": _cache[3] || (_cache[3] = 
        value => {
          workloadType.value = (Object.keys(_unref(workloadTypesLabels)) as Dashboard_WorkloadType[]).find(key => _unref(workloadTypesLabels)[key] === value) || null
          _unref(setWorkloadFilter)(_unref(workloadType) as Dashboard_WorkloadType);
          _unref(matomo)?.trackEvent({
            category: 'Dashboard Filter',
            action: 'Apply Workload type',
            name: value || '',
          });
          })
          }, null, 8, ["model-value", "options"]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})